<template>
    <module-card
        v-bind="params"
        :loading="loading"
        :error="error"
        :errorText="errorText"
        :permissions="permissions"
        :roles="roles"
        :retryFunction="retryFunction"
        :segmentations="segmentations"
        @visibleChanged="$emit('visibleChanged', $event)"
    >
        <template slot="content">
            <div class="financial-card__item">
                <div class="financial-card__item__label">
                    Total pago
                </div>
                <div :class="`financial-card__item__value ${ parseNumber(item.paidTotal) > 0
                    ? 'financial--color'
                    : ''
                }`">
                    {{ item.paidTotal }}
                </div>
            </div>
            <div class="financial-card__item">
                <div class="financial-card__item__label">
                    Saldo a vencer
                </div>
                <div class="financial-card__item__value">
                    {{ item.toExpireTotal }}
                </div>
            </div>
            <div :class="`financial-card__item ${parseNumber(item.lateTotal)
                ? 'error--text'
                : ''
            }`">
                <div class="financial-card__item__label">
                    Saldo em atraso <i v-if="parseNumber(item.lateTotal)" class="bexsicon-alert" />
                </div>
                <div class="financial-card__item__value">
                    {{ item.lateTotal }}
                </div>
            </div>
        </template>
        <template slot="actions">
            <v-btn
                class="slin-btn"
                @click="$router.push({ name: 'financialPosition' })"
                :style="{ color: params.themeColor }"
            >
                <i class="bexsicon-finantial-status-sm" />
                Ver posição financeira
            </v-btn>
        </template>
    </module-card>
</template>

<script>
import ModuleCard from '@/components/layout/Card'
import { PROFILES, ROLES, SEGMENTATIONS } from '../../utils/constants'

export default {
    components: {
        ModuleCard
    },
    data() {
        return {
            permissions: [
                PROFILES.ADMIN_PROFILE,
                PROFILES.ADMIN_BEXS_PROFILE,
                PROFILES.ADMIN_HR_PROFILE,
                PROFILES.HR_PROFILE,
                PROFILES.FINANCIAL_PROFILE,
                PROFILES.ADMIN_FINANCIAL_PROFILE
            ],
            roles: [
              ROLES.CLIENT_ROLE
            ],
            segmentations: [
              SEGMENTATIONS.ASSOCIATIVE__REHEARSE_STATUS,
              SEGMENTATIONS.ASSOCIATIVE_REHEARSED__REHEARSE_STATUS,
              SEGMENTATIONS.SFH__REHEARSE_STATUS,
              SEGMENTATIONS.SETTLED__REHEARSE_STATUS,
              SEGMENTATIONS.DIRECT__REHEARSE_STATUS,
              SEGMENTATIONS.LAUNCH__CONSTRUCTION_STAGE,
              SEGMENTATIONS.IN_CONSTRUCTION__CONSTRUCTION_STAGE,
              SEGMENTATIONS.DELIVERED__CONSTRUCTION_STAGE,
              SEGMENTATIONS.KEYS_DELIVERED__CONSTRUCTION_STAGE,
            ],
        }
    },
    props: {
        item: {
            type: Object,
            required: true,
        },
        params: {
            type: Object,
            required: true,
        },
        error: {
            type: Boolean,
            required: true,
        },
        loading: {
            type: Boolean,
            required: true,
        },
        errorText: String,
        retryFunction: Function
    },
    methods: {
        parseNumber (v) {
            return v ? parseFloat(v.replace('R$', '')) : v
        },
    }
}
</script>

<style lang="scss" scoped>
.financial-card {
    &__item {
        font-size: .9em;
        border-bottom: 1px solid rgb(240, 240, 240);
        padding: .5em;
        display: flex;

        &__label {
            flex: .5;
        }

        &__value {
            text-align: right;
            flex: .5;
        }
    }
}
</style>



// WEBPACK FOOTER //
// ./src/components/modules/FinancialSummaryCard.vue